<template>
  <!-- Edit Dialog -->
  <base-dialog
    v-model="dialog.show"
    max-width="700px"
    min-width="300px"
    scrollable
    :title="`${titleDialog} ${$t('sidebar.layer.name')}`"
    width="50%"
  >
    <base-form ref="form" lazy-validation @submit.stop="onSubmit">
      <field-group
        v-model="dialog.data.name"
        autofocus
        :error-messages="dialog.error.name"
        filled
        label="Tên hiển thị"
        no-label
      ></field-group>
      <field-group filled :label="$t('layer.form.extent')">
        <template #input>
          <v-row>
            <v-col cols="3">
              <field-group
                v-model="dialog.data.minx"
                :error-messages="dialog.error.minx"
                filled
                :label="$t('layer.form.south')"
                no-label
                type="number"
              ></field-group>
            </v-col>
            <v-col cols="3">
              <field-group
                v-model="dialog.data.miny"
                :error-messages="dialog.error.miny"
                filled
                :label="$t('layer.form.west')"
                no-label
                type="number"
              ></field-group>
            </v-col>
            <v-col cols="3">
              <field-group
                v-model="dialog.data.maxx"
                :error-messages="dialog.error.maxx"
                filled
                :label="$t('layer.form.east')"
                no-label
                type="number"
              ></field-group>
            </v-col>
            <v-col cols="3">
              <field-group
                v-model="dialog.data.maxy"
                :error-messages="dialog.error.maxy"
                filled
                :label="$t('layer.form.north')"
                no-label
                type="number"
              ></field-group>
            </v-col>
          </v-row>
        </template>
      </field-group>
      <field-group
        rows="2"
        type-input="v-textarea"
        no-resize
        filled
        no-label
        :label="$t('layer.description')"
        v-model="dialog.data.abstract"
        :error-messages="dialog.error.abstract"
      ></field-group>
    </base-form>

    <template v-slot:extra-btn>
      <base-button
        color="primary"
        :loading="dialog.loading"
        outlined
        :type-action="dialog.type"
        @click="onSubmit"
      >
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { EDIT_TYPE } from '@constant'
import { API_LAYER, API_STYLE, API_SRS } from '@api'
import { mapGetters } from 'vuex'
export default {
  components: {},
  props: {},
  data: () => ({
    dialog: {
      show: false,
      loading: false,
      data: { meta: {} },
      type: EDIT_TYPE.CREATE,
      error: {},
    },
    // srs: {
    //   items: [],
    //   loading: false,
    // },
  }),
  created() {
    // this.fetchSrs()
  },
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    titleDialog() {
      if (this.isCreateDialog) {
        return this.$i18n.t('actions.add')
      } else {
        return this.$i18n.t('actions.update')
      }
    },
    isCreateDialog() {
      return this.dialog.type == EDIT_TYPE.CREATE
    },
  },
  methods: {
    open(item, type) {
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.dialog.show = true
      this.dialog.type = type
      this.$set(this.dialog, 'data', Object.assign({}, item))
      // if (item.meta && item.meta.srs) this.dialog.data.srs = item.meta.srs
    },
    dialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: { meta: {} },
        type: EDIT_TYPE.CREATE,
        error: {},
      }
    },
    async onSubmit() {
      this.dialog.error = {}
      if (!(await this.$refs.form.validate())) return
      try {
        let data = Object.assign({}, this.dialog.data)
        this.dialog.loading = true
        let res = this.isCreateDialog
          ? await API_LAYER.create(data)
          : await API_LAYER.update(data.id, data)

        if (res && !res.error) {
          this.dialogClose()
          this.getData()
        }
        if (
          res &&
          res.error &&
          res.error.response &&
          res.error.response.status == 422
        ) {
          const { response } = res.error
          this.dialog.error = response.data.errors
        }
      } finally {
        this.dialog.loading = false
      }
    },

    getData() {
      this.$emit('reset')
    },
    // fetchSrs() {
    //   this.srs.loading = true
    //   API_SRS.list(this.srs.items.params)
    //     .then((res) => {
    //       this.srs.items = res.data
    //     })
    //     .finally(() => {
    //       this.srs.loading = false
    //     })
    // },
  },
}
</script>

<style scoped>
.v-btn {
  font-weight: 400;
}
</style>
